import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import "@/index.css";
import App from "@/App";

// PostHog analytics — initialised here (not as an inline <script>) so the
// Content-Security-Policy does not require 'unsafe-inline' on script-src.
posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
  // Session recording (rrweb) sets inline style attributes on DOM nodes to capture
  // CSS mutations, which the style-src CSP blocks: each mutation reports a different
  // hash so listing them all is infeasible. Disable recording; event capture still
  // works fully.
  disable_session_recording: true,
});

// Suppress spurious DataCloneError thrown when Chrome tries to serialise
// PerformanceServerTiming entries via the structured-clone algorithm.
// Moving this here (rather than an inline <script> in index.html) keeps the
// Content-Security-Policy free of 'unsafe-inline'.
window.addEventListener(
  "error",
  function (e) {
    if (
      e.error instanceof DOMException &&
      e.error.name === "DataCloneError" &&
      e.message &&
      e.message.includes("PerformanceServerTiming")
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
